const legalNotices = {
  title: "IMPRESSUM",
  intro: {
    title: "NUTZUNG DER DIENSTE",
    paragraphs: [
      "Die Gesellschaft iizenglish ist auf die Entwicklung, die Herausgabe und den Vertrieb von webbasierten und mobilen Anwendungen mit pädagogischer Zielsetzung für Fachkräfte, Organisationen, Institutionen sowie Privatpersonen spezialisiert.",
      "Der Zugang zur Webanwendung iizenglish sowie deren Nutzung unterliegen den nachstehenden Bedingungen sowie den geltenden gesetzlichen Bestimmungen.",
      "Durch den Zugriff auf die Website erklärt sich der Nutzer ohne Einschränkung oder Vorbehalt mit diesen Bedingungen einverstanden.",
    ],
  },
  editor: {
    title: "HERAUSGEBER DER WEBSITE",
    paragraphs: [
      "Firmenname: iizenglish SAS – 883 506 024 Handelsregister Paris (R.C.S.)",
      "Rechtsform: Vereinfachte Aktiengesellschaft (Société par actions simplifiée – SAS) mit einem Stammkapital von 1.000 €",
      "Geschäftssitz: 23, avenue Foch, 75116 Paris",
      "Umsatzsteuer-Identifikationsnummer (USt-IdNr.): FR75881212138",
      "Verantwortlich für die Veröffentlichung: Hervé Chevènement",
      "Kontakt: Bitte besuchen Sie die Seite „Kontakt“.",
    ],
  },
  contactingUs: {
    title: "Kontakt",
    paragraphs: [
      "23, avenue Foch, 75116 Paris, France",
      "+33 (0) 6 50 70 87 21",
      "contact@iizenglish.com",
    ],
  },
  host: {
    title: "HOSTING-ANBIETER",
    paragraphs: [
      "GETCAAS<br /> Adresse: 12 rue Albert Einstein<br /> 48000 Mende – Frankreich<br />",
      "Um diesen Hosting-Anbieter zu kontaktieren, besuchen Sie bitte die folgende Adresse: https://www.getcaas.io/<br /> ",
    ],
  },
  attributions: {
    title: "CREDITS",
    paragraphs: [
      "Entwicklung: Coopdev<br /> Web-Integration: Maëva Rouxel<br /> Grafikdesign: La Petite Planète<br /> Illustration: Bod’Z",
    ],
  },
  intellectualProperty: {
    title: "GEISTIGES EIGENTUM",
    paragraphs: [
      "Die allgemeine Struktur sowie die Texte, animierten Bilder, das Know-how und alle weiteren Bestandteile der Website sind ausschließliches Eigentum von iizenglish.",
      "Die auf der Website genannten Logos und Marken der genannten Unternehmen sind ausschließliches Eigentum ihrer jeweiligen Inhaber.",
      "Jede Darstellung, Vervielfältigung und/oder Nutzung der vorgenannten Marken, ganz oder teilweise, ist ohne vorherige schriftliche Zustimmung ihrer jeweiligen Inhaber untersagt.",
    ],
  },
  copyrights: {
    title: "URHEBERRECHTE",
    paragraphs: [
      "Jede vollständige oder teilweise Darstellung dieser Website durch Dritte ist ohne die ausdrückliche Genehmigung von iizenglish untersagt und stellt eine Urheberrechtsverletzung dar, die gemäß den Artikeln L. 335-2 ff. des französischen Gesetzbuches über geistiges Eigentum (Code de la propriété intellectuelle) geahndet wird.",
      "Die Einrichtung von Deep-Links zur Website www.iizenglish.com ist ohne die ausdrückliche und vorherige Zustimmung des Herausgebers der Website www.iizenglish.com untersagt.",
      "Darüber hinaus erfolgt die Nutzung der auf dieser Website enthaltenen Informationen ausschließlich auf eigene Verantwortung des Nutzers. iizenglish kann in keinem Fall und aus keinem Grund hierfür haftbar gemacht werden, unabhängig von den daraus entstehenden Folgen.",
      "Wir übernehmen keine Haftung für Fehler oder Auslassungen auf dieser Website.",
    ],
  },
  warning: {
    title: "ALLGEMEINER HAFTUNGSAUSSCHLUSS",
    paragraphs: [
      "Der Zugang zur Website www.iizenglish.com wird den Internetnutzern unentgeltlich und ohne jegliche Gewährleistung seitens des Herausgebers zur Verfügung gestellt.",
      "Für die auf der Website verfügbaren Informationen, die aus externen Quellen stammen, kann keine Gewähr für deren Fehlerfreiheit, Vollständigkeit, Aktualität, Richtigkeit oder sonstige Eigenschaften übernommen werden.",
      "Folglich obliegt es dem Internetnutzer, die auf der Website bereitgestellten Informationen auf eigenes Risiko zu verwenden und sämtliche erforderlichen Überprüfungen in eigener Verantwortung vorzunehmen.",
      "iizenglish kann in keiner Weise für die von den Internetnutzern vorgenommene Auslegung der auf ihrem Blog bereitgestellten Angaben, Informationen und Ratschläge – gleich welcher Art – sowie für die daraus resultierenden Folgen haftbar gemacht werden.",
      "Die Betreiber von Handels-, Dienstleistungs-, privaten oder IT-Websites (usw.), die über diese Website aufgerufen werden können, sind allein verantwortlich für die Einhaltung sämtlicher auf ihre Leistungen gegenüber Endkunden anwendbarer gesetzlicher und regulatorischer Vorschriften, insbesondere der Gesetze und Verordnungen in Bezug auf:",
      [
        "den Fernabsatz",
        "den Verbraucherschutz",
        "irreführende oder täuschende Werbung",
        "die Preisangaben",
        "die Produktkonformität",
      ],
    ],
  },
};

export default legalNotices;
